import { createFileRoute } from '@tanstack/react-router'

import { GlobalLoadingState } from '../../../../components/molecules/global-loading-state.tsx'
import { ReferralNotAvailablePage } from '../../../../components/pages/referral/referral-not-available-page.tsx'
import { ReferralPage } from '../../../../components/pages/referral/referral-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'
import { useIsBrokerClient } from '../../../../lib/hooks/use-is-broker-client.ts'

function ReferralsPortalRoute() {
  const { isBrokerClient, isPending: isBrokerClientPending } = useIsBrokerClient({ context: 'customer' })

  if (isBrokerClientPending) {
    return <GlobalLoadingState />
  }

  return (
    <PermissionChecker requiredPermissions={['contract.read']}>
      {isBrokerClient ? <ReferralNotAvailablePage /> : <ReferralPage />}
    </PermissionChecker>
  )
}

export const Route = createFileRoute('/(customer)/_portal/referrals')({
  component: ReferralsPortalRoute,
})
